import type { DesktopDisplayMode } from '../../types';

/** get responsive card sizes given a certain grid column spec */
export const getCardSize = (displayMode: DesktopDisplayMode, highlight?: boolean) => {
  const isFullWidth = highlight && displayMode === 'moreInformation';

  if (isFullWidth) return 'col-span-full';

  const isWide = highlight && (displayMode === 'cards' || displayMode === 'largeCards');

  return isWide ? 'col-span-2' : 'col-span-1';
};
